import { render, staticRenderFns } from "./ask-mobile-popover.vue?vue&type=template&id=fdfae06e"
import script from "./ask-mobile-popover.vue?vue&type=script&lang=ts"
export * from "./ask-mobile-popover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdfae06e')) {
      api.createRecord('fdfae06e', component.options)
    } else {
      api.reload('fdfae06e', component.options)
    }
    module.hot.accept("./ask-mobile-popover.vue?vue&type=template&id=fdfae06e", function () {
      api.rerender('fdfae06e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/ask-mobile-popover.vue"
export default component.exports